<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
    <nav
        class="sidebar fixed top-0 bottom-0 z-50 h-full min-h-screen w-[280px] m-2.5 lg:m-0 transition-all duration-300">
        <div class="lg:h-full bg-white rounded-xl lg:rounded-none dark:bg-[#102030]">
            <div class="flex items-center justify-between px-4 py-3">
                <a routerLink="/" class="main-logo flex gap-3 shrink-0 items-center">
                    <img class="ml-[5px] w-8 flex-none" src="/assets/images/logo.png" alt="" />
                    <span
                        class="logo-text align-middle text-2xl font-light ltr:ml-1.5 rtl:mr-1.5 dark:text-white-light lg:inline">Brickhub</span>
                </a>
                <a href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})">
                    <svg class="m-auto h-5 w-5" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 19L7 12L13 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path opacity="0.5" d="M16.9998 19L10.9998 12L16.9998 5" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </a>
            </div>
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                @if (navLockHint) {
                <div
                    class="mx-4 mt-2 rounded-lg border border-amber-300 bg-amber-100 px-3 py-2 text-xs text-amber-950 dark:border-amber-800 dark:bg-amber-900/40 dark:text-amber-50">
                    {{ navLockHint }}
                </div>
                }
                <ul class="relative space-y-0.5 p-4 py-0 font-normal">
                    @if (canSeeBuildersNav) {
                    <li class="nav-item">
                        <a routerLink="/builders" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-users-group class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Builders' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if (isNavLocked) {
                    <li class="nav-item">
                        <a routerLink="/my-profile" class="group" routerLinkActive="active"
                            (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-user [fill]="true" class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'My Profile' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if (!isNavLocked) {
                    @if (canSeeDashboardNav) {
                    <li class="nav-item">
                        <a routerLink="/dashboard" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-dashboard class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Dashboard' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if (canSeeProjectsNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('project-management') }"
                            (click)="onAccordionClick($event, 'project-management')">
                            <div class="flex items-center">
                                <icon-menu-apps class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Project management' | translate }}</span>
                            </div>
                            <div
                                [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('project-management') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('project-management')"
                            class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/projects" routerLinkActive="active"
                                        [ngClass]="{ active: isProjectNavActive() }"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Project' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/projects/documents" routerLinkActive="active"
                                        [ngClass]="{ active: isProjectDocumentNavActive() }"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Project Document' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/projects/work-progress" routerLinkActive="active"
                                        [ngClass]="{ active: isWorkProgressNavActive() }"
                                        (click)="toggleMobileMenu()">{{ 'Work Progress' | translate }}</a>
                                </li>
                                @if (canSeePaymentScheduleNav) {
                                <li>
                                    <a routerLink="/projects/payment-schedule" routerLinkActive="active"
                                        [ngClass]="{ active: isPaymentScheduleNavActive() }"
                                        (click)="toggleMobileMenu()">{{ 'Payment Schedule' | translate }}</a>
                                </li>
                                }
                            </ul>
                        </div>
                    </li>
                    }

                    @if (canSeePreSaleNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('pre-sale') }"
                            (click)="onAccordionClick($event, 'pre-sale')">
                            <div class="flex items-center">
                                <icon-menu-notes class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Pre-sale' | translate }}</span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('pre-sale') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('pre-sale')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li *hasPermission="'VIEW_CAMPAIGNS'">
                                    <a routerLink="/campaigns" routerLinkActive="active" (click)="toggleMobileMenu()">{{
                                        'Campaigns' | translate }}</a>
                                </li>
                                <li *hasPermission="'VIEW_SOCIAL_HUB'">
                                    <a routerLink="/social-hub" routerLinkActive="active" (click)="toggleMobileMenu()">{{
                                        'Social Hub' | translate }}</a>
                                </li>
                                <li *hasPermission="'VIEW_PEOPLE'">
                                    <a routerLink="/people" routerLinkActive="active" (click)="toggleMobileMenu()">{{
                                        'People' | translate }}</a>
                                </li>

                                <li *hasPermission="'VIEW_LEADS'">
                                    <a routerLink="/leads" routerLinkActive="active" (click)="toggleMobileMenu()">{{
                                        'Leads' | translate }}</a>
                                </li>
                                <li *hasPermission="'VIEW_OPPORTUNITIES'">
                                    <a routerLink="/opportunities" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Opportunities' | translate }}</a>
                                </li>
                                <li *hasPermission="['VIEW_MEETINGS', 'VIEW_LEADS']">
                                    <a routerLink="/calendar-events" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Meetings' | translate }}</a>
                                </li>
                                <li *hasPermission="'VIEW_FORMIQ'">
                                    <a routerLink="/formiq" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">{{
                                        'FormIQ' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    }

                    @if (canSeePropertyBookingsNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('property-bookings') }"
                            (click)="onAccordionClick($event, 'property-bookings')">
                            <div class="flex items-center">
                                <icon-menu-contacts class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Property Bookings' | translate }}</span>
                            </div>
                            <div
                                [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('property-bookings') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('property-bookings')"
                            class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/property-bookings" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Bookings' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/property-bookings/loans" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Loans' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/property-bookings/property-registration" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Property Registration' | translate }}</a>
                                </li>
                                @if (canSeeDemandPaymentsNav) {
                                <li>
                                    <a routerLink="/property-bookings/demand-payments" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Demand & Payments' | translate }}</a>
                                </li>
                                }
                                <li>
                                    <a routerLink="/property-bookings/documents" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Documents' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    }
                    @if (canSeePaymentTransactionsNav) {
                    <li class="nav-item">
                        <a routerLink="/property-bookings/payment-transactions" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }" (click)="onNavClick($event, isNavLocked)">
                            <div class="flex items-center">
                                <icon-cash-banknotes class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Payment Transaction' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if (canSeeActivitiesNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('activities') }"
                            (click)="onAccordionClick($event, 'activities')">
                            <div class="flex items-center">
                                <icon-activity class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Activity' | translate }}</span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('activities') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('activities')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/activities/notes" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">{{
                                        'Notes' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/activities/tasks" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">{{
                                        'Tasks' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/activities/lists" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">{{
                                        'Lists' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    }

                    @if (canSeeOffersNav) {
                    <li class="nav-item">
                        <a routerLink="/offers" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-invoice class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Offers' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if (canSeeIncentiveReportsNav) {
                    <li class="nav-item">
                        <a routerLink="/incentive-reports" class="group" routerLinkActive="active"
                            (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-charts class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Incentive Reports' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if (canSeeInvoicesNav) {
                    <li class="nav-item">
                        <a routerLink="/invoices" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-documentation class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Invoices' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if (canSeePaymentsNav) {
                    <li class="nav-item">
                        <a routerLink="/payments" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-menu-mailbox class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Payments' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if (canSeePriceManagementNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('price-management') }"
                            (click)="onAccordionClick($event, 'price-management')">
                            <div class="flex items-center">
                                <icon-tag class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Price Management' | translate }}</span>
                            </div>
                            <div
                                [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('price-management') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('price-management')"
                            class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li>
                                    <a routerLink="/price-management/base-rate-masters" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Base Rate Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/price-management/floor-rise-masters" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Floor Rise Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/price-management/gst-masters" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'GST Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/price-management/tds-masters" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'TDS Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/price-management/stamp-duty-configurations" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Stamp Duty Configuration' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/price-management/other-charges-masters" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Other Charges Master' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/price-management/quote-price-masters" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Quote Price Master' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    }

                    @if (canSeeTemplateConfigNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('templates-config') }"
                            (click)="onAccordionClick($event, 'templates-config')">
                            <div class="flex items-center">
                                <icon-layout-grid class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Templates Config' | translate }}</span>
                            </div>
                            <div
                                [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('templates-config') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('templates-config')"
                            class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li *hasPermission="'VIEW_CP_EMAIL_TEMPLATES'">
                                    <a routerLink="/template-config/email-templates" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Email Templates' | translate }}</a>
                                </li>
                                <li *hasPermission="'VIEW_CP_WHATSAPP_TEMPLATES'">
                                    <a routerLink="/template-config/whatsapp-templates" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Whatsapp Templates' | translate }}</a>
                                </li>
                                <li *hasPermission="'VIEW_CP_DOCUMENT_TEMPLATES'">
                                    <a routerLink="/template-config/document-templates-rte" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Document Templates' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    }

                    @if (canSeeBankManagementNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('bank-management') }"
                            (click)="onAccordionClick($event, 'bank-management')">
                            <div class="flex items-center">
                                <icon-credit-card class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Bank Management' | translate }}</span>
                            </div>
                            <div
                                [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('bank-management') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('bank-management')"
                            class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                @if (canSeeBankApfNav) {
                                <li>
                                    <a routerLink="/bank/bank-apf" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Bank APF' | translate }}</a>
                                </li>
                                }
                                @if (canSeeBankOffersNav) {
                                <li>
                                    <a routerLink="/bank/bank-offers" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Bank Offers' | translate }}</a>
                                </li>
                                }
                                @if (canSeeBankFeesNav) {
                                <li>
                                    <a routerLink="/bank/fees-charges" routerLinkActive="active"
                                        [routerLinkActiveOptions]="{ exact: true }"
                                        (click)="toggleMobileMenu()">{{ 'Fees & Charges' | translate }}</a>
                                </li>
                                }
                            </ul>
                        </div>
                    </li>
                    }

                    @if (canSeeApprovalManagementNav) {
                    <li class="nav-item">
                        <a routerLink="/approval-management" class="group" routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }" (click)="toggleMobileMenu()">
                            <div class="flex items-center">
                                <icon-circle-check class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Approval Management' | translate }}</span>
                            </div>
                        </a>
                    </li>
                    }

                    @if (canSeeRulesNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('rules-and-automations') }"
                            (click)="onAccordionClick($event, 'rules-and-automations')">
                            <div class="flex items-center">
                                <icon-menu-todo class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Rules & Automations' | translate }}</span>
                            </div>
                            <div
                                [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('rules-and-automations') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('rules-and-automations')"
                            class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li *hasPermission="['VIEW_APPROVAL_RULES', 'MANAGE_USERS']">
                                    <a routerLink="/rules-and-automations/approval-rules" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Approval Rules' | translate }}</a>
                                </li>
                                <li *hasPermission="['VIEW_ASSIGNMENT_RULES', 'MANAGE_USERS']">
                                    <a routerLink="/rules-and-automations/assignment-rules" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Assignment Rules' | translate
                                        }}</a>
                                </li>
                                <li *hasPermission="['VIEW_SCORING_RULES', 'MANAGE_USERS']">
                                    <a routerLink="/rules-and-automations/scoring-rules" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Scoring Rules' | translate
                                        }}</a>
                                </li>
                                <li *hasPermission="['VIEW_CP_GENERIC_MASTERS', 'MANAGE_CP_GENERIC_MASTERS']">
                                    <a routerLink="/rules-and-automations/generic-master" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Generic Master' | translate
                                        }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    }

                    @if (canSeeUserManagementNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('user-management') }"
                            (click)="onAccordionClick($event, 'user-management')">
                            <div class="flex items-center">
                                <icon-users class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'User Management' | translate }}</span>
                            </div>
                            <div
                                [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('user-management') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('user-management')"
                            class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li *hasPermission="['VIEW_DEPARTMENTS', 'MANAGE_DEPARTMENTS']">
                                    <a routerLink="/user/departments" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Departments' | translate
                                        }}</a>
                                </li>
                                <li *hasPermission="['VIEW_ROLES_PERMISSIONS', 'MANAGE_ROLES']">
                                    <a routerLink="/user/roles-permissions" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Roles & Permissions' | translate
                                        }}</a>
                                </li>
                                <li *hasPermission="['VIEW_INTERNAL_USERS', 'MANAGE_USERS']">
                                    <a routerLink="/user/internal-users" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Internal Users' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    }

                    @if (canSeeIntegrationsNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('integrations') }"
                            (click)="onAccordionClick($event, 'integrations')">
                            <div class="flex items-center">
                                <icon-link class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'Integrations' | translate }}</span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('integrations') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('integrations')"
                            class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                @if (canSeeSocialHubNav) {
                                <li>
                                    <a routerLink="/social-hub" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Social Hub' | translate }}</a>
                                </li>
                                }
                                @if (canManageIntegrationsNav) {
                                <li>
                                    <a routerLink="/integrations/vendor-configuration" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Vendor Configuration' | translate
                                        }}</a>
                                </li>
                                <li>
                                    <a routerLink="/integrations/vendor-apis" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Vendor APIs' | translate }}</a>
                                </li>
                                <li>
                                    <a routerLink="/integrations/kyc-configurations" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'KYC Configurations' | translate
                                        }}</a>
                                </li>
                                }
                                @if (canViewVendorLogsNav) {
                                <li>
                                    <a routerLink="/integrations/vendor-api-logs" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Vendor API Logs' | translate
                                        }}</a>
                                </li>
                                }
                            </ul>
                        </div>
                    </li>
                    }
                    }

                    @if (canSeeSystemNav) {
                    <li class="accordion menu nav-item">
                        <button type="button" class="nav-link group w-full"
                            [ngClass]="{ active: activeDropdown.includes('system') }"
                            (click)="onAccordionClick($event, 'system')">
                            <div class="flex items-center">
                                <icon-menu-authentication class="shrink-0 group-hover:!text-primary" />
                                <span
                                    class="text-black ltr:pl-3 rtl:pr-3 dark:text-[#506690] dark:group-hover:text-white-dark">{{
                                    'System' | translate }}</span>
                            </div>
                            <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('system') }">
                                <icon-caret-down />
                            </div>
                        </button>
                        <div [@slideDownUp]="!activeDropdown.includes('system')" class="accordion-content text-xs">
                            <ul class="sub-menu text-gray-500">
                                <li *hasPermission="['VIEW_COMPANIES', 'MANAGE_COMPANIES']">
                                    <a routerLink="/system/companies" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Companies' | translate }}</a>
                                </li>
                                @if (canSeeSettingsNav) {
                                <li *hasPermission="['VIEW_SETTINGS', 'EDIT_SETTINGS']">
                                    <a routerLink="/settings" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Settings' | translate }}</a>
                                </li>
                                }
                                <li *hasPermission="'VIEW_AUDIT_LOGS'">
                                    <a routerLink="/system/audit-logs" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Audit Logs' | translate }}</a>
                                </li>
                                <li *hasPermission="'cp_audit.view'">
                                    <a routerLink="/system/audit-trail" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Audit Trail' | translate }}</a>
                                </li>
                                <li *hasPermission="'VIEW_RECYCLE_BIN'">
                                    <a routerLink="/system/recycle-bin" routerLinkActive="active"
                                        (click)="toggleMobileMenu()">{{ 'Recycle Bin' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>
                    }
                </ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>